<template>
  <div class="flip-selector" :class="{ open, 'is-loading': isLoading }">
    <dropdown-select
      v-model="value"
      :options="values"
      :multiple="false"
      :label-parser="labelParser"
      :disabled="isDisabled || isLoading"
      @open="open = true"
      @close="open = false"
    />
  </div>
</template>

<script>
import DropdownSelect from './DropdownSelect.vue'

export default {
  components: { DropdownSelect },
  model: {
    prop: 'selection',
    event: 'update'
  },
  props: ['disabled', 'dimensions', 'isLoading'],
  data() {
    return {
      open: false
    }
  },
  computed: {
    isNDSC() {
      return /DF_NDSC$/i.test(this.$store.state.query.mainCubeId)
    },
    flip() {
      return this.$store.state.query.flip
    },
    isDisabled: {
      get() {
        return this.disabled || this.$store.state.query.chart === 'choropleth'
          && this.$route.params.mode == 'indicator'
      },
    },
    values () {
      return this.dimensions
        .map(d => ({id: d.id, labels: { en: this.$lng(d.name.en, d.id) }, type: d.type}))
    },
    value: {
      get() {
        const dim = this.values.find(d => d.type === 'country')
        return { id: dim.id, labels: dim.name }
      },
      set([ val ]) {
        if (val.id === this.defaultDim.id) {
          this.$store.commit('flip', false)
        } else {
          this.$store.commit('flip', val.type)
        }
      }
    },
    defaultDim() {
      if (this.flip) {
        return this.values.find(d => d.type === this.flip)
      }

      return this.values.find(d => d.type === 'country')
    }
  },
  methods: {
    labelParser([ id ]) {
      const dim = this.values.find(d => d.id === id)
      const value = this.$lng(dim.labels[this.lng], dim.id);
      if (this.isMobile) {
        return `<label>Show chart by:</label><span class="value">${value}</span>`
      }

      return `<label>Show chart by:</label><br/><span class="value">${value}</span>`;
    }
  }
}
</script>

<style lang="stylus">
.flip-selector
  flex: 1
  display: flex
  justify-content: center
  align-items: center
  position: relative

  .mobile &
    border-bottom: 1px solid $gray

  &.open
    .dropdown-select__label
      border-bottom: none

  &.is-loading::after
    position: absolute
    left: 0
    top: 0
    width: 100%
    height: 100%
    background-color: transparent
    z-index: 10
    cursor: progress
    content: ""

  .dropdown-select
    width: 100%

  .dropdown-select__label
    text-align: start
    text-align: center

    .mobile &
      text-align: left
      display: flex

      > label
        margin-top: 0.15em
        line-height: 1.75
        margin-left: 0

        &:after
          display: none
          transform: translate(-1.1em, -50%)

    > label
      margin-right: 0.5em
      font-size: 0.85em
      line-height: 1.25
      position: relative
      margin-left: 1.75em
      /* margin-left: 1.5em */

      &:after
        content: " "
        position: absolute
        left: 0px
        top: 50%
        width: 1.25em
        height: 1.25em
        transform: translate(-1.75em, -50%)
        background-image url(../../assets/icons/icon--flip.svg)
        background-repeat: no-repeat
        background-size: contain
        background-position: center

      .mobile &
        +m-breakpoint(landscape)
          font-size: 0.8em

    > .value
      m-ellipsis(100%)
      margin-right: 0.5em
      margin-top: 0.15em
      font-size: 0.85em
      line-height: 1.75
      display: block

      .mobile &
        +m-breakpoint(landscape)
          font-size: 0.8em

</style>
